import React, { useEffect, useState, useRef } from "react";
import useApp from "hooks/useApp";
import { Select, Layer, Logo } from "components";
import styles from "../index.module.css";
import Lib from "library";
import { financeLoanDetailState_3 } from "./states";
import { useRecoilState } from "recoil";
import { lib } from "crypto-js";

const FinanceLoanDetailLayer_3 = () => {
  const App = useApp();
  const [accordionOpen, setAccordionOpen] = useState(true);
  const [layerControl, setLayerControl] = useRecoilState(
    financeLoanDetailState_3
  );

  const seq = layerControl.seq;
  const dclsMonth = layerControl.dclsMonth;
  const finCoNo = layerControl.finCoNo;
  const finPrdtCd = layerControl.finPrdtCd;
  // const credit = layerControl.data;
  const fciId = layerControl.fciId;
  const crdtGradAvg = layerControl.crdtGradAvg; // 평균대출금리

  const [credit, setCredit] = useState(null); // 상세데이터
  const [lend, setLend] = useState(""); // 금리구분
  const [grad, setGrad] = useState(1); // 신용등급

  const [creditOpLst, setCreditOpLst] = useState(null);

  const [lendOption, setLendOption] = useState(null);
  const [gradOption, setGradOption] = useState(null);

  const [score, setScore] = useState(""); // [신용점수] 평균 금리
  const [rate, setRate] = useState(""); // [신용점수] 신용등급에 따른 금리

  const openAccordion = () => setAccordionOpen(!accordionOpen);

  // 신용등급 옵션값 처리
  const gradSetLst = (data, value) => {
    const _data = data.map((credit) => ({
      ...credit,
      crdtGradnm_1: "900점 초과",
      crdtGradnm_4: "801~900점",
      crdtGradnm_5: "701~800점",
      crdtGradnm_6: "601~700점",
      crdtGradnm_10: "501~600점",
      crdtGradnm_11: "401~500점",
      crdtGradnm_12: "301~400점",
      crdtGradnm_13: "300점 이하",
    }));
    const _item = _data.find((v) =>
      typeof v.crdtLendRateTypeNm !== "undefined"
        ? v.crdtLendRateTypeNm === value
        : null
    );

    
    const useItemList = [
      {
        isUse: _item.crdtGrad1 !== 'null',
        useType: "crdtGrad1",
        useName: "crdtGradnm_1",
      },
      {
        isUse: _item.crdtGrad4 !== 'null',
        useType: "crdtGrad4",
        useName: "crdtGradnm_4",
      },
      {
        isUse: _item.crdtGrad5 !== 'null',
        useType: "crdtGrad5",
        useName: "crdtGradnm_5",
      },
      {
        isUse: _item.crdtGrad6 !== 'null',
        useType: "crdtGrad6",
        useName: "crdtGradnm_6",
      },
      {
        isUse: _item.crdtGrad10 !== 'null',
        useType: "crdtGrad10",
        useName: "crdtGradnm_10",
      },
      {
        isUse: _item.crdtGrad11 !== 'null',
        useType: "crdtGrad11",
        useName: "crdtGradnm_11",
      },
      {
        isUse: _item.crdtGrad12 !== 'null',
        useType: "crdtGrad12",
        useName: "crdtGradnm_12",
      },
      {
        isUse: _item.crdtGrad13 !== 'null',
        useType: "crdtGrad13",
        useName: "crdtGradnm_13",
      },
      {
        isUse: _item.crdtGradAvg !== null,
        useType: "crdtGradAvg",
        useName: "crdtGradAvg",
      },
    ];

    // 값이 존재하는 것만 select 목록에 표시
    const _list = useItemList
      .map((useItem, index) => {
        if (useItem.isUse && useItem.useType !== 'null') {
          return {
            idx: useItem.useType !== "crdtGradAvg" ? index + 1 : 0,
            type: _item[useItem.useType],
            nm: _item[useItem.useName],
          };
        } else {
          return null;
        }
      })
      .filter((useItem) => useItem !== null);

    console.log("gradSetLst _list", _list);

    // const _lst = [
    // 	{ idx: 1, type: _item["crdt_grad_1"], nm: _item["crdt_grad_nm_1"] },
    // 	{ idx: 2, type: _item["crdt_grad_4"], nm: _item["crdt_grad_nm_4"] },
    // 	{ idx: 3, type: _item["crdt_grad_5"], nm: _item["crdt_grad_nm_5"] },
    // 	{ idx: 4, type: _item["crdt_grad_6"], nm: _item["crdt_grad_nm_6"] },
    // 	{ idx: 5, type: _item["crdt_grad_10"], nm: _item["crdt_grad_nm_10"] },
    // 	{ idx: 6, type: _item["crdt_grad_11"], nm: _item["crdt_grad_nm_11"] },
    // 	{ idx: 7, type: _item["crdt_grad_12"], nm: _item["crdt_grad_nm_12"] },
    // 	{ idx: 8, type: _item["crdt_grad_13"], nm: _item["crdt_grad_nm_13"] }
    // ]
    //
    // console.log("gradSetLst _lst", _lst);
    
    // 신용등급 옵션리스트 설정
    setGradOption(_list);
    // 신용등급에 따른 금리 값 설정
    console.log('찾아라!!!',_list.find((idx) => idx.idx == grad).type);
    // const user = _list.find((idx) => idx.idx == grad)
    setRate(_list.find((idx) => idx.idx == grad).type);
    // setGrad(user.nm);

    console.log('신용등급', grad);
    console.log('신용등급에 따른 금리', rate);
    return _list;
  };

  // 금리구분 옵션값 처리
  const creditRate = (data) => {

    // 신용등급에 따른 점수 노출값 처리
    const _data = data.map((credit) => ({
      ...credit,
      crdtGrad1: "900점 초과",
      crdtGrad4: "801~900점",
      crdtGrad5: "701~800점",
      crdtGrad6: "601~700점",
      crdtGrad10: "501~600점",
      crdtGrad11: "401~500점",
      crdtGrad12: "301~400점",
      crdtGrad13: "300점 이하",
    }));
    // 금리구분 옵션 이름 맵핑
    const lendOptions = new Map(
      _data.map((crdt) => [crdt.crdtLendRateTypeNm])
    );
    const _lend = [...lendOptions].map(([type]) => ({crdtLendRateTypeNm: type}));
    
    // 금리구분 기준 초기 값 선택 
    const _item = _data.find(
      (v) => v.crdtLendRateTypeNm === _lend[0].crdtLendRateTypeNm
    );


    if (_lend.length > 0) {
      setLendOption(_lend); // 금리 전체 옵션
      gradSetLst(data, _lend[0].crdtLendRateTypeNm); // 초기 선택한 금리 기준 신용점수 옵션값 셋팅
      setLend(_lend[0].crdtLendRateTypeNm); // 금리 값
    }
    console.log('_lend', _lend)
    console.log('_item', _item)
    if (
      typeof _item !== "undefined" &&
      _item !== null &&
      Lib.isNotNull(_item)
    ) {
      setScore(_item.crdtGradAvg);
      setGrad(1);
    }

    console.log('금리구분', _lend[0].crdtLendRateTypeNm);
    console.log('금리구분에 따른 평균 금리', _item.crdtGradAvg);
  };

  // 개인대출 getcreditRateOption
  const getcreditRateOption = (fciId) => {
    Lib.myGet(
      `/api/recomm/credit/v1/${fciId}`, (data) => {
        console.log("신용대출 : " , data.data);
        setCreditOpLst(data.data.options); // 원본 옵션 데이터
        creditRate(data.data.options); // 금리구분에 따른 옵션값 초기 처리
        setCredit(data.data)
      }
    );
    // Lib.post(
    //   `/api/finance/creditLoanOption?dclsMonth=${month}&finCoNo=${codeNo}&finPrdtCd=${prdtCode}`,
    //   (data) => {
    //     //console.log("신용대출 : " + JSON.stringify(data));
    //     setCreditOpLst(data);
    //     creditRate(data);
    //   }
    // );
  };

  // 상세보기시 기간, 금리가 안 보이는 오류가 있어서 매번 조회하도록 수정(layerControl.show 속성추가. 20221020)
  useEffect(() => {
    layerControl.show && getcreditRateOption(fciId);
  }, [layerControl.show, fciId]);

  return (
    <Layer
      show={layerControl.show}
      closeLayer={() => setLayerControl((prev) => ({ ...prev, show: false }))}
    >
      {credit && (
        <div className="page">
          <div className="shadow">
            <div className="padding">
              <div className="flex-justify_between align_center mt_10">
                <div className={styles["detail-title"]}>
                  <span>{credit.korCoNm}</span>
                  <p className="mt_5">{credit.finPrdtNm}</p>
                  <i className="tag tag-box tag-red mt_10">개인신용대출</i>
                </div>
                {/* <div className="img-box img-symbol img-symbol-lg ml_10">
									<Logo code={credit.fin_co_no} style={{ 'width': '6rem', 'height': '6rem' }} />
								</div> */}
              </div>
              <ul className={`${styles["count-list"]} mt_20`}>
                <li>
                  <p>평균 대출 금리</p>
                  <strong>
                    {!crdtGradAvg
                      ? "정보없음"
                      : `${Number(crdtGradAvg).toFixed(2)}%`}
                  </strong>
                </li>
              </ul>
            </div>
          </div>
          {gradOption ? (
            <div className="shadow">
              <div className="padding">
                <div
                  className={`${
                    accordionOpen ? "active" : ""
                  } accordion-title flex-justify_between align_center`}
                  onClick={openAccordion}
                >
                  <h3>내가 이 대출을 받는다면?</h3>
                  <i className="icon icon_accordion_arrow" />
                </div>
                <div className="accordion-content">
                  <div className="flex-justify_center mt_40">
                    <i className="icon icon_finance_loan" />
                  </div>
                  <div className={`${styles["question-area"]} mt_20`}>
                    <div className={styles.sec}>개인신용대출 상품을</div>
                    <div className={styles.sec}>
                      <Select
                        className="mr_10"
                        title="금리구분"
                        selected={lend}
                        data={
                          lendOption &&
                          lendOption.map((lend, index) => {
                            return {
                              key: lend.crdtLendRateTypeNm,
                              value: lend.crdtLendRateTypeNm,
                            };
                          })
                        }
                        onSelect={async (key, value) => {
                          setLend(value);
                          const _lst = gradSetLst(creditOpLst, value);
                          const _gradValue = _lst.find((v) => v.idx === grad);
                          setRate(_gradValue.type);
                          setScore(_lst.find((v) => v.idx === 0).type);
                          console.log("[신용점수]평균 금리 : " + score);
                          console.log("[신용점수]점수에 따른 금리 : " + rate);
                        }}
                      ></Select>
                      로
                    </div>
                    <div className={styles.sec}>
                      신용점수가
                      <Select
                        className="mx_10"
                        title="신용점수"
                        selected={grad}
                        data={
                          gradOption &&
                          gradOption.map((grad, index) => {
                            return grad.idx > 0 && { key: grad.nm, value: grad.idx };
                          })
                        }
                        onSelect={(key, value) => {
                          setGrad(value);
                          const _item = gradOption.find((v) => v.idx === value);
                          //console.log("???_item????",_item.type)
                          setRate(_item.type);
                          console.log("[신용점수]평균 금리 : " + score);
                          console.log("[신용점수]점수에 따른 금리 : " + rate);
                        }}
                      ></Select>
                      일 경우
                    </div>
                  </div>
                  {!Lib.isNull(rate) && !Lib.isNull(score) && (
                    <div className={`${styles["answer-box"]} mt_20`}>
                      점수에 따른 금리는{" "}
                      <strong>{parseFloat(rate).toFixed(2)}%</strong>이고,
                      <br />
                      평균 금리는{" "}
                      <strong>{parseFloat(score).toFixed(2)}%</strong>이네요.
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : null}
          <div className="padding">
            <ul
              className="list-item list-item-left"
              style={{ fontSize: "1.2rem" }}
            >
              {credit.joinWay != null && credit.joinWay != "-" && (
                <li>
                  <span>가입방법</span>
                  <span>{credit.joinWay}</span>
                </li>
              )}
              {credit.crdtPrdtTypeNm != null &&
                credit.crdtPrdtTypeNm != "-" && (
                  <li>
                    <span>대출종류</span>
                    <span>{credit.crdtPrdtTypeNm}</span>
                  </li>
                )}
              {credit.cbName != null && credit.cbName != "-" && (
                <li>
                  <span>CB회사명</span>
                  <span>{credit.cbName}</span>
                </li>
              )}
              {(credit.dclsStrtDay != null ||
                credit.dclsEndDay != null) && (
                <li>
                  <span>공시기간</span>
                  <span>
                    {credit.dclsStrtDay} ~ {credit.dclsEndDay}
                  </span>
                </li>
              )}
            </ul>
            <div className={`${styles["list-guide"]} mt_50`}>
              금융감독원의 금융상품 API를 통해 제공하는 정보입니다.
            </div>
          </div>
        </div>
      )}
    </Layer>
  );
};

export default FinanceLoanDetailLayer_3;
